module.exports = __webpack_public_path__ + "static/media/washing-hand.71dafe1b.svg";